export default "__VITE_ASSET__D21PTYEO__"